export default {"src":"/_next/static/media/time.b46cb45a.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};